import {
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    IReservation,
    Reservation
} from '../model/reservation';
import {
    IInvoice,
    Payment
} from '../model/payment';

@Component({
    selector: 'invoice-component',
    template: require('./invoice.component.html'),
    styles: [require('./invoice.component.css')]
})

export class InvoiceComponent implements OnInit, OnDestroy {

    public invoiceTypes = [
        {
            type: 'TYPE_PREPAYMENT',
            label: 'Varausmaksu'
        },
        {
            type: 'TYPE_INTERIM_PAYMENT',
            label: 'Välimaksu'
        },
        {
            type: 'TYPE_FINAL_PAYMENT',
            label: 'Loppumaksu'
        }
    ];
    public vatPc            = 10;
    public id               : number;
    public hash             : string;
    public reservation      : IReservation;
    public invoice          : IInvoice;
    private sub             : any;

    constructor(
        private ReservationResource: Reservation,
        private PaymentResource : Payment,
        private route: ActivatedRoute
    ) {}

    public ngOnInit() {
        document.getElementsByClassName("frontPageTop")[0].innerHTML = '';
        document.getElementsByClassName("frontPageBottom")[0].innerHTML = '';

        this.sub = this.route.params.subscribe((params) => {
            this.id = +params['id']; // (+) converts string 'id' to a number
            this.hash = params['hash'];

            this.ReservationResource.getByInvoice({id: this.id, hash: this.hash})
                .$observable
                .subscribe((reservation: IReservation) => {
                    this.reservation = reservation;
                    for (let invoice of reservation.order.invoices) {
                        if (invoice.id === this.id) {
                            this.invoice = invoice;
                        }
                    }
                });
        });
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    public order() {
        this.PaymentResource.sendInvoice(this.invoice)
            .$observable
            .subscribe((response : {paymentURL : string}) => {
                window.location.href = response.paymentURL;
            });
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/invoice/invoice.component.ts